import { render, staticRenderFns } from "./FaceInput.vue?vue&type=template&id=1c4382f5&scoped=true&"
import script from "./FaceInput.vue?vue&type=script&lang=js&"
export * from "./FaceInput.vue?vue&type=script&lang=js&"
import style0 from "./FaceInput.vue?vue&type=style&index=0&id=1c4382f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4382f5",
  null
  
)

export default component.exports